import { exists } from '../exists/exists';

export const stringHasValue = (str: string) => {
  return exists(str) && typeof str === 'string' && str.trim() !== '';
};
